import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';
import HiddenSeoTime, { VisibleSeoTime } from '../../../../../common/seoUpdateTime';

import { formatVideoDuration } from '../../../utils/timeUnit';
import { asyncGetPlayNum } from '../../../utils/playNumUnit';

class TitleWrap extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        ads: PropTypes.object,
    };

    state = {
        playNum: '',
    };

    async componentDidMount() {
        const { guid, base62Id } = this.props.content;
        const guids = guid || base62Id;
        
        const playNum = await asyncGetPlayNum([{ guid: guids }]);

        this.setState({
            playNum,
        });
    }

    render() {
        const {
            vSource,
            title,
            breadCrumbdata,
            newsTime,
            updateTime,
            duration,
            guid,
            wemediaEAccountId,
            columnName,
            subscribe,
            base62Id
        } = this.props.content;
        const { playNum } = this.state;
        const { ads } = this.props;
        const guids = guid || base62Id;
        
        const crumb = () => {
            if (vSource === 'ucms' && breadCrumbdata) {
                return (
                    <span className={styles.crumb}>
                        {breadCrumbdata &&
                            // eslint-disable-next-line array-callback-return
                            breadCrumbdata.map((item, index) => {
                                if (index === 0) {
                                    return null;
                                } else if (index === 1) {
                                    return (
                                        <a href={item.url} target="_blank" key={index}>
                                            {item.title}
                                        </a>
                                    );
                                } else if (item.title) {
                                    return `>${item.title}`;
                                }
                            })}
                    </span>
                );
            } else if ((vSource === 'cmpp' || !breadCrumbdata) && wemediaEAccountId && columnName) {
                return (
                    <span className={styles.crumb}>
                        自媒体
                        {wemediaEAccountId ? (
                            <React.Fragment>
                                {'>'}
                                <a
                                    href={`https://ishare.ifeng.com/mediaShare/home/${wemediaEAccountId}/media`}
                                    target="_blank">
                                    {columnName}
                                </a>
                            </React.Fragment>
                        ) : null}
                    </span>
                );
            }
        };

        return (
            <header className={`${styles.titleWrap} clearfix`}>
                <div className={styles.titleInner}>
                    <h1>{title}</h1>
                    <div className={styles.info}>
                        {/* {crumb()} */}
                        <span className={styles.creatDate}>
                            <i className={styles.creatDate_icon} />
                            <VisibleSeoTime publishTime={newsTime}>{newsTime}</VisibleSeoTime>
                            <HiddenSeoTime publishTime={newsTime} updateTime={updateTime} />
                        </span>
                        <span className={styles.duration}>
                            <i className={styles.duration_icon} />
                            {formatVideoDuration(duration)}
                        </span>
                        <span className={styles.playNum}>
                            <i className={styles.playNum_icon} />
                            {playNum ? playNum[guids] : 0}
                        </span>
                        <span>{subscribe?.lastArticleAddress || ''}</span>
                    </div>
                </div>
                <div className={styles.ad}>
                    <Ad content={ads} />
                </div>
            </header>
        );
    }
}

export default errorBoundary(TitleWrap);
